import React, { PureComponent } from 'react';
import { Icon } from 'semantic-ui-react';
import { Waypoint } from 'react-waypoint';
import { func, shape, bool, number } from 'prop-types';
import { connect } from 'react-redux';
import { openGallery } from 'Redux/modules/webChat/allMedia/actions';
import { PAGE_SIZE } from 'Constants/webchat';

import GridImage from './GridImage';

class AllMedia extends PureComponent {
  componentDidMount() {
    const { getAllMedia, conversationId } = this.props;
    if (conversationId) {
      getAllMedia({ conversationId, count: PAGE_SIZE });
    }
  }

  openPreview = selectedImage => {
    const { conversationId } = this.props;

    this.props.openGallery(conversationId, selectedImage);
  };

  handleWaypointEnter = () => {
    const { allMedia, getAllMedia, conversationId } = this.props;
    const {
      meta: { currentLength },
      status,
      list,
    } = allMedia;
    if (status !== 0 && currentLength === PAGE_SIZE) {
      const timestamp = new Date(list[list.length - 1].createdAt).valueOf();
      if (list[list.length - 1] && conversationId) {
        getAllMedia({ conversationId, count: PAGE_SIZE, timestamp });
      }
    }
  };

  render() {
    const { allMedia } = this.props;

    const {
      list,
      meta: { currentLength },
    } = allMedia;

    const isLoadMore = currentLength === PAGE_SIZE;

    return (
      <div className="all-medias">
        <GridImage list={list} openPreview={this.openPreview} />
        {isLoadMore && (
          <Waypoint onEnter={this.handleWaypointEnter} onLeave={this.handleWaypointLeave}>
            <div className="text-center">
              <Icon name="spinner" loading size="big" />
            </div>
          </Waypoint>
        )}
      </div>
    );
  }
}

AllMedia.propTypes = {
  openGallery: func.isRequired,
  getAllMedia: func.isRequired,
  allMedia: shape({}).isRequired,
  isCollapsed: bool.isRequired,
  conversationId: number.isRequired,
};

const mapStateToProps = () => ({});

const mapDispatchToProps = {
  openGallery,
};

export default connect(mapStateToProps, mapDispatchToProps)(AllMedia);
